import './Loader.css';

import type { FunctionComponent } from 'react';

interface LoaderProps {
  color: 'light' | 'dark' | 'current-color';
  size: 'small' | 'medium';
}

export const Loader: FunctionComponent<LoaderProps> = ({ color, size }) => (
  <div
    data-testid="loader"
    className={`loader-container loader-container-${size}`}
  >
    <span className={`loader loader-${color} loader-${size}`} />
  </div>
);
